import { useState } from 'react';
import { ProposalsList } from './ProposalsList';
import { NewProposal } from './NewProposal';
import { ProcessingView } from './ProcessingView';
import { ReviewView } from './ReviewView';

// ProposalEditor v1 (pages[]) fue eliminado 2026-09-17: creaba propuestas
// en un formato que el visor público V2 (blocks[]) no sabe renderizar, así
// que su output aterrizaba como "Propuesta en preparación". Ahora todas las
// propuestas se generan vía la ingesta IA (NewProposal → ProcessingView →
// ReviewView) que produce directamente blocks v2.

type View =
  | { type: 'list' }
  | { type: 'new' }
  | { type: 'processing'; proposalId: string; jobId: string }
  | { type: 'review'; proposalId: string };

export default function ProposalsModule() {
  const [view, setView] = useState<View>({ type: 'list' });

  switch (view.type) {
    case 'new':
      return (
        <NewProposal
          onBack={() => setView({ type: 'list' })}
          onProcessing={(proposalId, jobId) => setView({ type: 'processing', proposalId, jobId })}
        />
      );

    case 'processing':
      return (
        <ProcessingView
          proposalId={view.proposalId}
          jobId={view.jobId}
          onReview={(proposalId) => setView({ type: 'review', proposalId })}
          onBack={() => setView({ type: 'list' })}
        />
      );

    case 'review':
      return (
        <ReviewView
          proposalId={view.proposalId}
          onBack={() => setView({ type: 'list' })}
        />
      );

    default:
      return (
        <ProposalsList
          onEdit={(id) => setView({ type: 'review', proposalId: id })}
          onCreate={() => setView({ type: 'new' })}
        />
      );
  }
}
